import React, { useEffect, useRef } from "react";
import "./site.css";
import "./toast.css";
import "./tracking.css";
import "./photo-slide.css";
import "./invoice-print.css";
import "./fabric.css"
import { Routes, Route } from "react-router-dom";
import { createTheme, Customizer } from "@fluentui/react";
import { Authentication } from "./components/common/views/Authentication";
import FooterView from "./components/common/views/FooterView";
import { Utils } from "./components/common/views/Utils";
import { useHomeVM } from "./components/home/viewmodels/HomeVM";
import MenuView from "./components/common/views/MenuView";
import ScanInvoicePrint from "./components/invoices/pages/ScanInvoicePrint.page";
import ChangePasswordPage from "./components/accounts/pages/ChangePassword.page";
import ForgotPasswordPage from "./components/accounts/pages/ForgotPassword.page";
import SignupPage from "./components/accounts/pages/signup.page";
import CustomerContact from "./components/customers/pages/CustomerContact.page";
import CustomerProfile from "./components/customers/views/CustomerProfileView";
import Invoice from "./components/invoices/pages/Invoice.page";
import Order from "./components/orders/pages/Order.page";
import Payment from "./components/payments/pages/Payment.page";
import LoginPage from "./components/accounts/pages/Login.page";
import AppLink from "./components/home/pages/AppLink.page";
import Home from "./components/home/pages/Home.page";
import PricePolicy from "./components/home/pages/PricePolicy.page";
import Privacy from "./components/home/pages/Privacy.page";
import Term from "./components/home/pages/Terms.page";
import InvoiceLabel from "./components/invoices/pages/InvoiceLabel.page";
import UserDeletion from "./components/home/pages/UserDeletion.page";
import BeesInvoice from "./components/BeesInvoices/pages/BeesInvoice.page";
import AdminProduct from "./components/products/pages/AdminProduct.page";
import Product from "./components/products/pages/Product.page";
import Cart from "./components/carts/pages/Cart.page";
import useBasicCartVM from "./components/carts/viewmodels/BasicCartVM";
import Checkout from "./components/orders/pages/Checkbox.page";
import Favorite from "./components/favorites/pages/Favorite.page";

const customTheme = createTheme({
    fonts: {
        medium: {
            fontFamily: "Segoe UI"
        },
    },
});

const myTheme = createTheme({
    palette: {
        themePrimary: '#000000',
        themeLighterAlt: '#898989',
        themeLighter: '#737373',
        themeLight: '#595959',
        themeTertiary: '#373737',
        themeSecondary: '#2f2f2f',
        themeDarkAlt: '#252525',
        themeDark: '#151515',
        themeDarker: 'black',
        neutralLighterAlt: '#faf9f8',
        neutralLighter: '#f3f2f1',
        neutralLight: '#edebe9',
        neutralQuaternaryAlt: '#e1dfdd',
        neutralQuaternary: '#d0d0d0',
        neutralTertiaryAlt: '#c8c6c4',
        neutralTertiary: '#595959',
        neutralSecondary: '#373737',
        neutralPrimaryAlt: '#2f2f2f',
        neutralPrimary: '#000000',
        neutralDark: '#151515',
        black: '#0b0b0b',
        white: '#ffffff'
    }
});

//loadTheme(myTheme);

const App: React.FC = () => {
    const hasLoaded = useRef(false);
    Authentication.setupAjaxAuthorization();

    const homeVM = useHomeVM();
    const cartVM = useBasicCartVM();

    useEffect(() => {
        if (hasLoaded.current) return;

        hasLoaded.current = true;

        homeVM.onLoad();
        cartVM.onLoad();
    }, [homeVM, cartVM]);

    const url = window.location.href.toLowerCase();
    const isPrint = url.indexOf("/label") > -1 || url.indexOf("product-barcodes") > -1 || url.indexOf("bees-invoice") > -1;
    const hideSearch = url.indexOf("admin-products") > -1 || url.indexOf("invoice-print") > -1 || url.indexOf("external-payment") > -1;

    const padding = isPrint ? "" : "pv-20"

    var cssHomepage = "home-page-container";
    var cssHomeBody = "home-page-body" + (Utils.isMobile() ? "-mobile" : "");

    if (isPrint) {
        cssHomepage = "center";
        cssHomeBody = "";
    }

    const routes = () => {
        return <div className="pv-10">
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/price-policy" element={<PricePolicy />} />
                <Route path="/terms" element={<Term />} />
                <Route path="/userDeletion" element={<UserDeletion />} />
                <Route path="/apple-app-site-association" element={<AppLink />} />

                <Route path="/login" element={<LoginPage />} />
                <Route path="/signup" element={<SignupPage />} />
                <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                <Route path="/change-password" element={<ChangePasswordPage />} />

                <Route path="/profiles" element={<CustomerProfile />} />
                <Route path="/contacts" element={<CustomerContact />} />

                <Route path="/orders" element={<Order />} />
                <Route path="/invoices" element={<Invoice />} />
                <Route path="/payments" element={<Payment />} />
                <Route path="/invoice-print" element={<ScanInvoicePrint />} />
                <Route path="/invoice-prints">
                    <Route path="label/:ids" element={<InvoiceLabel />} />
                </Route>
                <Route path="/bees-invoice/:token" element={<BeesInvoice />} />

                <Route path="/favorites" element={<Favorite />} />
                <Route path="/carts/:id" element={<Cart />} />
                <Route path="/checkout/:cartId" element={<Checkout />} />

                <Route path="/products" element={<Product addToCart={cartVM.add} />} />
                <Route path="/admin-products" element={<AdminProduct addToCart={cartVM.add} />} />
                {/*<Route path="/product-barcodes/:barcodes" element={<ProductBarcode />} />*/}
            </Routes>
        </div>;
    }

    return (
        <Customizer settings={{ theme: customTheme }}>
            <div className={cssHomepage} id="top-page">
                <div className={cssHomeBody}>
                    {!isPrint && <div>
                        <MenuView
                            banners={homeVM.banners}
                            cartId={cartVM.cartId}
                            getCartCountText={cartVM.getCountText}
                        />
                    </div>}

                    <div style={{ minHeight: "70vh" }}>
                        {routes()}
                    </div>

                    {!isPrint && <div>
                        <FooterView contacts={homeVM.contacts} />
                    </div>}
                </div>
            </div>
        </Customizer>
    );
};

export default App;